/* Product Detail Page (core webshop's item.html generator template) sits
 * outside any [data-rfhq-theme] scope, same root cause already diagnosed
 * and fixed for #product-filters, /shop-by-category, and the Legal Document
 * pages: RFHQ's --rfhq-* custom properties only exist inside a themed
 * ancestor, never globally, so every rule targeting .product-container.item-main
 * (and everything under it - gallery, price, variant swatches, Add to Cart,
 * description, reviews) was silently rendering its literal CSS fallback
 * only. Same fix: claim it data-rfhq-owned and hand it to the existing
 * site-theme fallback.
 *
 * Reuses pdp_context.js's isPdp()/getPdpMainBlock() - the same PDP-detection
 * helpers tryon_widget.js and ar_viewer.js already mount on - rather than
 * re-deriving PDP detection here.
 */

import { isPdp, getPdpMainBlock } from './pdp_widgets/pdp_context.js';

frappe.ready(function () {
	if (!isPdp()) return;

	var claim = function (el) {
		if (!el) return;
		el.setAttribute('data-rfhq-owned', '1');
		if (window.rfhqApplyOwnedThemeFallback) window.rfhqApplyOwnedThemeFallback(el);
	};

	// item.html's own root structure is two SIBLING .product-container divs,
	// not one - .item-main (image/price/add-to-cart, what getPdpMainBlock()
	// finds) closes before a second, plain .product-container (no
	// .item-main class) opens for specs/reviews/recommendations. Found live:
	// theming only the first left "Ratings & Reviews" still on a white
	// background. Both need the fallback, independently.
	claim(getPdpMainBlock());
	document.querySelectorAll('.product-container:not(.item-main)').forEach(claim);
	// Core's own "Recommended" rail (item.html's recommended_item_row loop) -
	// separate from websitehq's own carousel/grid rail, only shown when
	// enable_recommendations is on and no template-owned rail already ran.
	document.querySelectorAll('.recommended-item-section').forEach(claim);
});
